module.exports = __webpack_public_path__ + "img/prayer-journal_B095GG2CWQ.4f76b103.jpg";